export default __webpack_public_path__ + "static/media/snowflakes.ec9261b5.svg";